module.exports = __webpack_public_path__ + "img/icon_map_zngg_c.fd224892.png";